import { motion } from 'motion/react'
import { prefersReducedMotion } from '$javascript/utils/utils'

export default function CustomerLogoCarousel({ partnerLogos }) {
    return (
        <div>
            <div
            className="mb-4 text-center">
                <h3
                    style={{
                        fontSize: 'var(--text-sm)',
                        fontWeight: '600',
                        color: 'var(--color-neutral-500)',
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em',
                    }}
                >
                    Trusted by Leading Organizations
                </h3>
            </div>

            <div
                style={{
                    position: 'relative',
                    overflow: 'hidden',
                    maxWidth: '1200px',
                    margin: '0 auto'
                }}
            >
                {/* Left Fade Mask */}
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: '100px',
                        background: 'linear-gradient(to right, white, transparent)',
                        zIndex: 1,
                        pointerEvents: 'none'
                    }}
                />

                {/* Right Fade Mask */}
                <div
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        bottom: 0,
                        width: '100px',
                        background: 'linear-gradient(to left, white, transparent)',
                        zIndex: 1,
                        pointerEvents: 'none'
                    }}
                />

                {/* Scrolling Logos */}
                <motion.div
                    animate={
                        prefersReducedMotion()
                            ? {}
                            : {
                                x: [0, -1050],
                                transition: {
                                    x: {
                                        repeat: Infinity,
                                        repeatType: 'loop',
                                        duration: 20,
                                        ease: 'linear'
                                    }
                                }
                            }
                    }
                    style={{
                        display: 'flex',
                        gap: 'var(--space-2xl)',
                        alignItems: 'center',
                        padding: 'var(--space-lg) 0'
                    }}
                >
                    {/* Duplicate logos twice for seamless loop */}
                    {[...partnerLogos, ...partnerLogos].map((partner, index) => (
                        <div
                            key={index}
                            style={{
                                width: '140px',
                                minWidth: '140px',
                                height: 'auto',
                                padding: 'var(--space-sm)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img
                                src={partner.src}
                                alt={partner.name}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    filter: 'grayscale(100%)',
                                    opacity: 0.6,
                                    transition: 'filter 0.3s ease, opacity 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.filter = 'grayscale(0%)'
                                    e.currentTarget.style.opacity = '1'
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.filter = 'grayscale(100%)'
                                    e.currentTarget.style.opacity = '0.6'
                                }}
                            />
                        </div>
                    ))}
                </motion.div>
            </div>
        </div>
    );
}